import { render, staticRenderFns } from "./MediaConfig.vue?vue&type=template&id=386e382d&scoped=true"
import script from "./MediaConfig.vue?vue&type=script&lang=js"
export * from "./MediaConfig.vue?vue&type=script&lang=js"
import style0 from "./MediaConfig.vue?vue&type=style&index=0&id=386e382d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386e382d",
  null
  
)

export default component.exports